"use client";

import { Suspense, useEffect } from "react";

import { hasMarketingConsent } from "@/lib/cookie-consent";
import { env } from "@/lib/env";
import {
  initAnalyticsProviders,
  onCookieConsentChange,
  trackPageView,
} from "@/lib/analytics";

/**
 * Loads the Google tag in the Consent Mode denied default, then applies the
 * stored or updated cookie choice. One manual page_view when analytics is granted.
 */
export default function AnalyticsBootstrap() {
  useEffect(() => {
    const sync = (analyticsGranted: boolean) => {
      const marketingGranted = hasMarketingConsent();
      initAnalyticsProviders({
        analytics: analyticsGranted,
        marketing: marketingGranted,
      });
      if (analyticsGranted && env.analytics.provider !== "none") {
        trackPageView();
      }
    };

    return onCookieConsentChange((granted: boolean) => {
      sync(granted);
    });
  }, []);

  return null;
}

/** Suspense boundary helper for AttributionCapture (useSearchParams). */
export function AttributionCaptureBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return <Suspense fallback={null}>{children}</Suspense>;
}
